import type {z} from "zod";

import {AddSupplierNoteBody} from "@project/sdk/engineering/zod";

import {requiredStringSchema} from "../../../../../../../shared/validation/required-string.schema";
import {noteFieldLabelIds} from "../../../../../../../support/messages/note.messages";

export const addSupplierNoteTitleSchema = requiredStringSchema(
  AddSupplierNoteBody.shape.title,
  noteFieldLabelIds.title,
);
export const addSupplierNoteContentSchema = requiredStringSchema(
  AddSupplierNoteBody.shape.content,
  noteFieldLabelIds.content,
);

export const addSupplierNoteFormSchema = AddSupplierNoteBody.extend({
  title: addSupplierNoteTitleSchema,
  content: addSupplierNoteContentSchema,
});
export type AddSupplierNoteFormPayload = z.output<typeof addSupplierNoteFormSchema>;

export const draftAddSupplierNoteFormSchema = addSupplierNoteFormSchema.partial();
export type DraftAddSupplierNoteFormPayload = z.output<typeof draftAddSupplierNoteFormSchema>;
